import React, { useMemo, JSX } from 'react';
import nextElection from '../data/nextElection.json';
import electionV2 from '../data/electionV2.json';
import { EuropeMapV2 } from '../items/EuropeMapV2';
import { dateString, excludeCountries, getAllCountries, withPartyOnPolls } from '../calculations/utilsV2';
import { countryDiv2 } from '../calculations/calculationDivsV2';
import { setParents, styleByGroup } from '../calculations/calcV2';

export const AllPageV2 = () => {
    const countryStats = electionV2.Stats.filter(x => !excludeCountries.includes(x.Country));
    useMemo(() => setParents(countryStats), []);

    const getValues = (data: CountryData, pollIndex: number) => { 
        const countryStat = countryStats.find(x => x.Country === data.Country && x.Region === data.Region);
        return countryStat && pollIndex < countryStat.Polls.length
            ? { values: withPartyOnPolls(countryStat, countryStat.Polls[pollIndex]), firm: countryStat.Polls[pollIndex].Firm ?? '', date: countryStat.Polls[pollIndex].DateTo } : null; 
    }
    const countries = getAllCountries();
    let allPolls = countries.map(x => { return { country: x, poll: getValues(x, 0) }; }).filter(x => x.poll);
    allPolls.push(...countries.map(x => { return { country: x, poll: getValues(x, 1) }; }).filter(x => x.poll));
    allPolls.push(...countries.map(x => { return { country: x, poll: getValues(x, 2) }; }).filter(x => x.poll));
    allPolls.forEach((x, i) => { 
        x["dt"] = x.poll ? new Date(x.poll.date).getTime() : new Date().getTime()
    });
    allPolls = allPolls.filter(x => { 
        var d = new Date();
        d.setDate(d.getDate() - 7);
        return d <= x["dt"]; 
    });
    allPolls = allPolls.sort((a, b) => b["dt"] - a["dt"] > 0 ? 1 : -1);

    const getPoll = (x: { country: CountryData, poll?: { values: PartyValue[], firm: string, date: string } | null }, i: number): JSX.Element => {
        if (!x.poll) return <div />;
        return <div key={i} className="hoverable">
            <div className="wrap margin8 padding8">
                <div className="highlight hlFirst">{x.poll.date}</div>&nbsp;
                {countryDiv2(x.country.Region ?? x.country.Country)}
                &nbsp;|&nbsp; 
                <div className="wrap">
                    {x.poll.values.sort((a, b) => b.value - a.value).filter(x => x.value >= 3).map(y => 
                        <div key={y.party} className={"highlight " + styleByGroup(y.group)}>{y.party}: {y.value}%</div>)
                    }
                </div> &nbsp;|&nbsp;
                <div className="highlight groupNi">
                    {x.poll.firm}
                </div>
            </div>
        </div>
    }

    const dots = (date: string): JSX.Element => {
        const now = new Date();
        const d = new Date(date);
        const days = (d.getTime() - now.getTime())/ (1000 * 3600 * 24);
        const res: JSX.Element[] = [];
        for (let i = 0; i < days; ++i) {
            res.push(<span key={i} className="dot groupNi" />);
        }
        return <span>
            &nbsp; {res.map(x => x)}
            <span className="dot groupG" />
        </span>
    }

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() - 1);
    const currentElection = nextElection.filter(x => x.date && new Date(x.date) <= new Date() && new Date(x.date) >= tomorrow);
    const commingElections = nextElection.filter(x => x.date && x.date.includes('-') && new Date(x.date) >= new Date()).slice(0, 10);

    return (<div>
        <EuropeMapV2 countryStats={countryStats} />
        <hr />
        { currentElection && currentElection[0] &&
            <>
                <span className="underline">election today</span>
                <div className="margin8">
                    {countryDiv2(currentElection[0].country)}
                </div>
            </>
        }
        <span className="underline">next election</span>
        <div className="margin8">
        {
            commingElections.map(x => 
                <div key={x.country} className="margin8"><span key={x.country} className="margin8 hoverable">
                    <span className="margin8">
                        {countryDiv2(x.country)}
                        &nbsp;<b>{dateString(new Date(x.date))}</b>
                        {dots(x.date)}
                    </span>
                    <br />
                </span></div>)
        }
        {
            [...new Set(nextElection.filter(x => x.date?.length === 4).map(x => x.date))]
                .map(x => <div key={x} className="margin8 hoverable">
                    <b className="margin8">{x}:</b> {nextElection.filter(y => y.date === x).map(y => <span key={y.country} className="margin8">
                        {countryDiv2(y.country)}
                    </span>)}
                </div>)
        }
        </div>
        <hr />
        {allPolls.length > 0 &&
            <span className="underline">latest polls</span>
        }
        {
            allPolls.map((x, i) => getPoll(x, i))
        }
        {allPolls.length > 0 &&
            <hr />
        }
        <a href="https://twitter.com/statostuff?ref_src=twsrc%5Etfw" className="twitter-follow-button" data-show-count="false">Follow @statostuff</a>
    </div>);
}

/*const ElectionResultLinkV2 = (): JSX.Element => {
    return (
        <div>
            <Link to={"/EU-result"}>
                <div className="highlight groupNi">
                    <img src={"/flags/EU.png"} alt="EU election results" height={14} />&nbsp;
                    <span className="dot groupSD" />
                    &nbsp;Live election data and predictions...
                </div>
            </Link>
        </div>
        );
    }*/